import { RouterProvider } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify';

import { appRouter } from '@/routes/app-router'

export default function App() {
  return (
    <>
      <RouterProvider router={appRouter} />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        transition={Slide}
      />
    </>
  )
}
